module.exports = __webpack_public_path__ + "img/logotype-click-gestao.510e60f5.svg";